import { ResourceQueryService } from '@lib/common-sdk';
import { BreadcrumbDataQuery } from '@lib/ui-components';

export const CompanyBranchBreadcrumbProvider: BreadcrumbDataQuery = {
  fetchFunction(id: string): () => Promise<any> {
    return function () {
      return ResourceQueryService.findOneByField<any>('/api/resource/companyBranchViews', 'branchId', id);
    };
  },

  mapToBreadcrumb(data: any): string {
    return data.name;
  },

  query: 'companyBranchViews',
};
